<template>
  <div class="component-form">
    <h1 class="form-title">Personal Information</h1>
    <div class="inp-flex mt-30">
      <div class="inp-wrap">
        <Input label="First name" :value="value.first_name" @input="handleInput($event, 'first_name')" />
      </div>
      <div class="inp-wrap">
        <Input label="Middle name" :value="value.middle_name" @input="handleInput($event, 'middle_name')" />
      </div>
      <div class="inp-wrap">
        <Input label="Last name" :value="value.last_name" @input="handleInput($event, 'last_name')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <GenderSelect
          label="Gender"
          placeholder="Gender"
          :isVerific="false"
          :value="value.gender ? value.gender.toString() : value.gender"
          @input="handleInput($event, 'gender')"
        />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <TimeZoneSelect label="Time Zone" placeholder="Time Zone" :isVerific="false" :value="value.time_zone" @input="handleInput($event, 'time_zone')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <AreaCodeSelect
          label="Country code"
          placeholder="Country code"
          :isVerific="false"
          :value="value.phone_code"
          @input="handleInput($event, 'phone_code')"
        />
      </div>
      <div class="inp-wrap">
        <Input label="Phone number" :value="value.phone" @input="handleInput($event, 'phone')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap big">
        <Input label="Email" :value="value.email" @input="handleInput($event, 'email')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap big">
        <Input label="University" :value="value.university" @input="handleInput($event, 'university')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <Input label="Class year" :value="value.class_year" @input="handleInput($event, 'class_year')" />
      </div>
      <div class="inp-wrap big">
        <Input label="Current Major" :value="value.current_major" @input="handleInput($event, 'current_major')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap large">
        <Textarea
          placeholder="Personal Introduction"
          :counter="false"
          :value="value.personal_introduction"
          @input="handleInput($event, 'personal_introduction')"
        />
      </div>
    </div>
    <p class="text mt-24">
      Please share details and stories including your second major if you have any, your special talent or things you do best, the
      organizations/departments/societies of Harvard where you take on an important role and the remarkable achievements you have made till now, the most
      difficult course/seminar you have ever attended at Harvard and you still got a grade A, the best off-campus internship experience you have had till now,
      some of your interesting hobbies, foreign languages that you can read/write/speak and any other stories that would surprise students.
    </p>
    <ImageUploader
      class="uploader-wrap mt-20"
      placeholder="Upload<br/>a profile photo"
      :value="value.profile_photo"
      @input="handleInput($event, 'profile_photo')"
      :role="ROLES.SL"
    />
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Input, GenderSelect, TimeZoneSelect, AreaCodeSelect, Button } from '../../../../components/form';
import ImageUploader from '../../../../components/form/Uploader/ImageUploader';
import Textarea from '../../../../components/form/Textarea/Prototype';
const SCHOOL_OPTIONS = [
  {
    label: 'school1',
    value: 'school1'
  }
];
const CLASS_OPTIONS = [
  {
    label: 'class1',
    value: 'class1'
  }
];
export default {
  name: 'PersonalInfomation',
  components: {
    Input,
    GenderSelect,
    TimeZoneSelect,
    AreaCodeSelect,
    Textarea,
    ImageUploader,
    Button
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ROLES() {
      return ROLES;
    },
    schoolData() {
      let ret = {
        areaId: [], // 学校 区域ID 顺序依次为 国家 省/州 城市
        schoolName: '', // 学校名称
        schoolId: '' // 学校ID
      };
      return ret;
    },
    SCHOOL_OPTIONS() {
      return SCHOOL_OPTIONS;
    },
    CLASS_OPTIONS() {
      return CLASS_OPTIONS;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    }
  }
};
</script>
